import MDB from './marketingdb';

//Import our boot functions
import bootSpa from './generate-boot-spa';

import {
    bootMediaLibrary, 
    bootMediaLibraryImageCrop
} from './Modules/MediaLibrary/index';

import {
    bootTemplateManager, 
    bootTemplateManagerIndex
} from './Modules/TemplateManager/index';

import bootSettingsDivisionMiscellaneous from './Modules/SettingsDivisionMiscellaneous/index';
import {
    bootIndex as bootOperatorTest,
    validateScheme as validateOperatorScheme
} from './Modules/Operator/index';

import {
    bootIndex as bootSprintPlanningIndex
} from './Modules/SprintPlanning/index';

import {
    bootIndex as bootJourneyBuilderIndex,
    bootOverview as bootJourneyBuilderOverview
} from './Modules/JourneyBuilder/index';

import {
    bootIndex as bootIoFormatIndex
} from './Modules/IoFormat/index';

//Setup namespacing
MDB.MediaLibrary = MDB.MediaLibrary || {};
MDB.TemplateManager = MDB.TemplateManager || {};
MDB.DmVisualizer = MDB.DmVisualizer || {};
MDB.Operator = MDB.Operator || {};
MDB.Settings = MDB.Settings || {};
MDB.SprintPlanning = MDB.SprintPlanning || {};
MDB.JourneyBuilder = MDB.JourneyBuilder || {};
MDB.IoFormat = MDB.IoFormat || {};

//Set our boot funcs
MDB.bootSpa = bootSpa;

MDB.MediaLibrary.boot = bootMediaLibrary;
MDB.MediaLibrary.bootCrop = bootMediaLibraryImageCrop;

MDB.TemplateManager.boot = bootTemplateManager;
MDB.TemplateManager.bootTemplateManagerIndex = bootTemplateManagerIndex;

MDB.SprintPlanning.bootIndex = bootSprintPlanningIndex;

MDB.Settings.bootDivisionMiscellaneous = bootSettingsDivisionMiscellaneous;

MDB.JourneyBuilder.bootIndex = bootJourneyBuilderIndex;
MDB.JourneyBuilder.bootOverview = bootJourneyBuilderOverview;

MDB.IoFormat.bootIndexVue = bootIoFormatIndex;

MDB.Operator.bootTest = bootOperatorTest;
MDB.Operator.validateScheme = validateOperatorScheme;
